import type { I18nTranslation } from '@crehana/i18n';

import type { B2B_CHECKOUT_PAGE_KEY } from '../constants';
import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export type TKeys = keyof (typeof es)[typeof B2B_CHECKOUT_PAGE_KEY];

const locales: I18nTranslation = { es, pt, en };

export default locales;
